/*eslint-disable*/
import { useState, useCallback } from 'react';
import debounce from 'lodash.debounce';
import {
  fetchUserDataFromZoho,
  convertEmpStatusToValue,
} from '../../../Utils/userDataUtil';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import {
  AUTHENTICATION_FAILED,
  OOPS_TRY_AGAIN,
} from '../../../Constants/strings';

const defaultEmployeeData = {
  employeeName: {},
  employeeId: '',
  employeeEmail: '',
  status: null,
};

const useMapEmployee = () => {
  const [loadingEmployeeList, setLoadingEmployeeList] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState(defaultEmployeeData);
  const { snackbarOpen } = useSnackbar();

  const fieldsToShowMapEmp = [
    'employeeId',
    'fullName',
    'emailId',
    'employeestatus',
    'photoSignedUrl',
    'totalExperience',
  ];

  const debouncedFetchUserInfo = useCallback(
    debounce(async (newInputValue, setEmpOptions) => {
      try {
        const employeeInfo = await fetchUserDataFromZoho(
          newInputValue,
          fieldsToShowMapEmp,
        );
        const activeEmployees = employeeInfo.filter(
          (employee) =>
            convertEmpStatusToValue(employee.employeestatus) === 1,
        );
        setLoadingEmployeeList(false);
        setEmpOptions(activeEmployees);
      } catch (error) {
        setLoadingEmployeeList(false);
        setEmpOptions([]);
      }
    }, 3000), // 3 seconds delay
    [],
  );

  const handleEmployeeNameChange = async (newInputValue) => {
    if (newInputValue?.length >= 3) {
      setLoadingEmployeeList(true);
      debouncedFetchUserInfo(newInputValue, setEmployeeOptions);
    } else {
      setLoadingEmployeeList(false);
      setEmployeeOptions([]);
    }
  };

  const handleEmployeeDetails = (newValue) => {
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      employeeName: newValue ?? {},
      employeeId: newValue?.employeeId ?? '',
      employeeEmail: newValue?.emailId ?? '',
      others: newValue?.others ?? '',
    }));
  };


  const handleOthersChange = (othersValue) => {
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      others: othersValue,
    }));
  };

  const handleEmployeeStatusDeatils = (event) => {
    setEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      status: event.target.value,
    }));
  };

  const handleResetEmployeeDetails = () =>
    setEmployeeDetails(defaultEmployeeData);

  const checkMapBtnDisabled = () => {
    const isEmployeeInfoFilled =
      Object.keys(employeeDetails.employeeName || {}).length > 0 &&
      employeeDetails.employeeId !== '' &&
      employeeDetails.employeeEmail !== '' &&
      employeeDetails.status !== null &&
      employeeDetails.status?.id !== undefined;
  
    const isOthersFilled = 
      employeeDetails.others && 
      employeeDetails.others !== '' && 
      employeeDetails.status !== null &&
      employeeDetails.status?.id !== undefined;
  
    return !(isEmployeeInfoFilled || isOthersFilled);
  };
  const handleResponse = (response) => {
  const responseData = response?.data;

  const getMessage = () => {
    return (
      response?.data?.response?.data?.error?.externalMessage ||
      responseData?.response?.data?.externalMessage ||
      responseData?.message || 
      responseData?.error?.externalMessage || 
      responseData?.response?.data?.error?.externalMessage || 
      responseData?.externalMessage ||
      OOPS_TRY_AGAIN
    );
  };

  const statusCode =
    response?.status ||
    responseData?.status ||
    responseData?.response?.data?.statusCode ||
    responseData?.error?.statusCode ||
    responseData?.response?.data?.error?.statusCode ||
    responseData?.statusCode;

  switch (statusCode) {
    case 200:
    case 201:
      snackbarOpen(getMessage(), 'success');
      break;
    case 400:
    case 404:
    case 401:
      snackbarOpen(getMessage(), 'warning');
      break;
    default:
      snackbarOpen(OOPS_TRY_AGAIN, 'warning');
      break;
  }
};

  return {
    loadingEmployeeList,
    employeeOptions,
    employeeDetails,
    setEmployeeDetails,
    handleEmployeeDetails,
    handleEmployeeNameChange,
    handleEmployeeStatusDeatils,
    handleResetEmployeeDetails,
    checkMapBtnDisabled,
    handleResponse,
    handleOthersChange
  };
};

export default useMapEmployee;
